import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getTickets() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_TICKETS_PAGE_REQUEST,
			payload: { loadingTickets: true }
		});

		//Get all tickets
		const tickets_response = await API.ticket.getTickets();

		if(tickets_response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_TICKETS_PAGE_ERROR,
				payload: {
					meta: tickets_response.meta,
					loadingTickets: false
				}
			});
			return;
		}

		const { tickets } = tickets_response.data;

		dispatch({
			type: ActionTypes.GET_TICKETS_PAGE_SUCCESS,
			payload: {
				tickets,
				loadingTickets: false
			}
		});
	};
}

export function getLaundryRooms() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_REQUEST,
			payload: { loadingLaundryRooms: true }
		});

		//Get all tickets
		const response = await API.ticket.getLaundryRooms();

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_ERROR,
				payload: {
					meta: response.meta,
					loadingLaundryRooms: false
				}
			});
			return;
		}

		const { laundry_rooms } = response.data;

		dispatch({
			type: ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_SUCCESS,
			payload: {
				laundry_rooms,
				loadingLaundryRooms: false
			}
		});
	};
}

export function getLaundryRoomMachines() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_REQUEST,
			payload: { loadingLaundryRoomMachines: true }
		});

		const response = await API.ticket.getLaundryRoomMachines();

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_ERROR,
				payload: {
					meta: response.meta,
					loadingLaundryRoomMachines: false
				}
			});
			return;
		}

		const { laundry_room_machines } = response.data;

		dispatch({
			type: ActionTypes.GET_TICKETS_PAGE_LAUNDRY_ROOMS_MACHINES_SUCCESS,
			payload: {
				laundry_room_machines,
				loadingLaundryRoomMachines: false
			}
		});
	};
}

export function getPaymentMethods() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_PAYMENT_METHODS_REQUEST,
			payload: { loadingPaymentMethods: true }
		});

		//Get all tickets
		const response = await API.ticket.getPaymentMethods();

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_PAYMENT_METHODS_ERROR,
				payload: {
					meta: response.meta,
					loadingPaymentMethods: false
				}
			});
			return;
		}

		const { payment_methods } = response.data;

		dispatch({
			type: ActionTypes.GET_PAYMENT_METHODS_SUCCESS,
			payload: {
				payment_methods,
				loadingPaymentMethods: false
			}
		});
	};
}

export function purchaseTicket(details) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_TICKET_PAGE_REQUEST,
			payload: { loadingSubmit: true }
		});

		const body = {
			ticket: {
				...details
			}
		};

		// create ticket
		const response = await API.ticket.purchaseTicket(body);

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.SUBMIT_TICKET_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { ticket } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_TICKET_PAGE_SUCCESS,
			payload: {
				loadingSubmit: false
			}
		});

		if (ticket.payment_method !== 'free') {
			if (ticket && ticket.redirect_url) {
				window.location.href = ticket.redirect_url;
			}
		}
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_TICKETS_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_TICKETS_PAGE
		});
	};
}
